export default {
      id: "instagram-usage",
      viewBox: "0 0 32 34",
      url: __webpack_public_path__ + "assets/icons/icon-sprite.svg#instagram-usage",
      toString: function () {
        return this.url;
      }
    }